/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-27 10:31:14
 * @LastEditTime: 2022-03-08 11:28:13
 */
import http from '@/axios/http'

// 根据模板Id获取变量列表
export function getParams(id, type, sortNum = 12) {
  return http({
    url: '/api2/variable/list',
    method: 'post',
    data: {
      mid: id,
      type,
      sortNum
    }
  })
}
// 根据终端id获取变量列表
export function getParamsByterminal(id) {
  return http({
    url: '/api2/variable/dtu/list',
    method: 'post',
    data: {
      dtuId: id,
      type: "0"
    }
  })
}
// 添加变量
export function addParams(data) {
  return http({
    url: '/api2/variable/add',
    method: 'post',
    data,
  })
}

// 编辑变量
export function editParams(data) {
  return http({
    url: '/api2/variable/edit',
    method: 'post',
    data,
  })
}
// 删除变量
export function deleteParams(id) {
  return http({
    url: '/api2/variable/del',
    method: 'post',
    data: {
      id,
      action: 2
    }
  })
}

// 下发监测变量
export function monitorParams(data) {
  return http({
    // url: '/api2/monitor/temp/variable',
    url: '/api2/monitor/variable',
    method: 'post',
    data,
  })
}

// 获取变量报警规则
export function getAlarm(data) {
  return http({
    url: '/api2/alarmRule/details',
    method: 'post',
    data: {
      vid: data
    },
  })
}
// 添加变量报警
export function addAlarm(data) {
  return http({
    url: '/api2/alarmRule/add',
    method: 'post',
    data,
  })
}
// 编辑变量报警规则
export function editAlarm(data) {
  return http({
    url: '/api2/alarmRule/edit',
    method: 'post',
    data,
  })
}